// /apps/patient/src/main.tsx
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { PatientProvider } from './contexts/PatientContext';
import { FeatureProvider } from './contexts/FeatureContext';
import App from './App';
import './index.css';
import { registerServiceWorker } from './services/registerServiceWorker';
import { getEnvironmentConfig } from './config/platforms';

// Set document title and meta tags based on platform
const config = getEnvironmentConfig();
document.title = config.appName;
document.querySelector('meta[name="description"]')?.setAttribute('content', config.platform.description);
document.querySelector('meta[name="theme-color"]')?.setAttribute('content', config.themeColor);
document.querySelector('meta[name="apple-mobile-web-app-title"]')?.setAttribute('content', config.appShortName);

// Register service worker for PWA
registerServiceWorker();

createRoot(document.getElementById('root')!).render(
  <StrictMode> 
    <PatientProvider>
      <FeatureProvider>
        <App />
      </FeatureProvider>
    </PatientProvider>
  </StrictMode>
);